import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService, UserProfile } from '../../features/authentication/services/auth.service';
import { StorageService } from './storage.service';
import { STORAGE_KEYS } from '../constants/app-constants';
import { API_ENDPOINTS } from '../constants/api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private authService = inject(AuthService);
  private storage = inject(StorageService);
  private http = inject(HttpClient);

  readonly profile = signal<UserProfile | null>(null);
  readonly isSubscriptionActive = signal<boolean>(
    this.storage.get(STORAGE_KEYS.SUBSCRIPTION_ACTIVE) !== 'false'
  );

  setSubscriptionActive(value: boolean): void {
    this.isSubscriptionActive.set(value);
    this.storage.set(STORAGE_KEYS.SUBSCRIPTION_ACTIVE, String(value));
  }

  loadProfile(): void {
    this.authService.getProfile().subscribe({
      next: (res) => {
        this.profile.set(res.data);
      },
    });
  }

  checkSubscriptionStatus(): void {
    this.http
      .get<{ success: boolean; message: string; data: { isSubscriptionActive: boolean } }>(
        API_ENDPOINTS.pharmacyVendor.subscription
      )
      .subscribe({
        next: (res) => this.setSubscriptionActive(res.data.isSubscriptionActive),
      });
  }

  clearProfile(): void {
    this.profile.set(null);
  }
}
